/**
 * JS-context color constants — mirrors the `tone.*`, `risk.*`, and `primary.*`
 * Tailwind tokens defined in tailwind.config.js. Use these in inline `style=`,
 * SVG attributes, and Recharts props where CSS classes cannot be applied.
 *
 * For Tailwind class usage prefer the token classes directly (e.g. `bg-tone-red-bg`).
 */

/** Semantic status tones — muted, maroon-harmonized. */
export const TONE_HEX = {
  red: { fg: '#9e4339', bg: '#f4e5e2', dark: '#85382f' },
  amber: { fg: '#8d6a3c', bg: '#f3ece0' },
  blue: { fg: '#6e5a74', bg: '#ece6ec' },
  slate: { fg: '#776d6e', bg: '#efeae8' },
} as const;

/** AML risk level — monochrome maroon intensity ramp. */
export const RISK_HEX = {
  bajo: '#c08a92',
  medio: '#a8505d',
  alto: '#7a1f2b',
  sin: '#b3a9aa',
} as const;

/** Brand colors for use in inline styles / SVG (Tailwind token equivalents in primary.*). */
export const BRAND_HEX = {
  primary: '#8a2e3c',
  primaryDark: '#5f1f29',
  primaryMid: '#a83f50',
  primaryDeep: '#4a141d',
} as const;

/**
 * Risk-threshold band colors for the MatrizRiesgo visualization bar.
 * Intentionally a traffic-light spectrum distinct from the semantic `tone.*` palette.
 */
export const THRESHOLD_HEX = {
  bajo: '#7a9b86',   // muted green — low risk band
  medio: '#d8a85b',  // amber/gold — medium risk band
  alto: '#b4524a',   // muted brick — high risk band
} as const;

/**
 * Designed cover-art gradients for the news rail — maroon-family palette.
 * CSP-safe (no external images). Each pair is [from, to] for a linear gradient.
 */
export const NEWS_GRADIENTS: [string, string][] = [
  ['#8a2e3c', '#4a141d'],
  ['#a8505d', '#5f1f29'],
  ['#7a1f2b', '#3a0f16'],
  ['#b07d3f', '#5f1f29'],
  ['#9e4339', '#5a201b'],
  ['#6e5a74', '#3a2440'],
];

/** Chart/SVG primitive colors (used in Recharts props and hand-rolled SVG). */
export const CHART_HEX = {
  ink: '#19211c',
  inkFaint: '#948b8d',
  track: '#eef0ec',
  gaugeTrack: '#e4e7e1',
  grid: '#ece4e3',
  panel: '#ffffff',
} as const;
